import { Injectable } from "@angular/core";
import { DataService } from "@app/core";
import { ContentProviderConnectCashRegisterRequestDto, ContentProviderConnectCashRegisterResponseDto } from "cfs-communication-pack";
import { ContentProviderType } from "clearline-api";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ContentProviderService {
  serviceUrl = "ContentProvider";

  constructor(private http: DataService) {}

  connectCashRegisterToProvider(
    providerType: ContentProviderType,
    cashRegisterId: number,
    data: ContentProviderConnectCashRegisterRequestDto
  ): Observable<ContentProviderConnectCashRegisterResponseDto> {
    return this.http.post<ContentProviderConnectCashRegisterResponseDto>(
      `${this.serviceUrl}/${providerType}/cashRegister/${cashRegisterId}/connect`,
      data
    );
  }
}
